<template>
  <div class="login-page">

    <!-- OVERLAY -->
    <div class="overlay">

      <div class="container h-100">

        <div class="row justify-content-center align-items-center h-100">

          <div class="col-11 col-sm-9 col-md-6 col-lg-4">

            <!-- CARD -->
            <div class="card login-card shadow-lg rounded-4 p-4">

              <!-- HEADER -->
              <div class="text-center mb-4">

                <!-- LOGO -->
                <img
                  src="@/assets/logo_baraka.jpeg"
                  alt="Boutique "
                  class="logo-baraka mb-3"
                />

                <!-- ICON -->
                <div class="baraka-icon mb-3">
                  <i class="bi bi-bag-fill"></i>
                </div>

                <h2 class="fw-bold mb-1 title-baraka">
                  Boutique
                </h2>

                <p class="text-muted small mb-0">
                  Plateforme moderne de gestion de boutique
                </p>

              </div>

              <!-- ERROR -->
              <div
                v-if="globalError"
                class="alert alert-danger py-2"
              >
                {{ globalError }}
              </div>

              <!-- FORM -->
              <form @submit.prevent="login" novalidate>

                <!-- EMAIL -->
                <div class="mb-3">

                  <label class="form-label fw-semibold">
                    Adresse email
                  </label>

                  <input
                    type="email"
                    v-model.trim="email"
                    class="form-control form-control-baraka"
                    :class="{ 'is-invalid': error.email }"
                    placeholder="ex: admin@gmail.com"
                    autocomplete="username"
                    autofocus
                    :disabled="isLoading"
                  />

                  <div class="invalid-feedback">
                    {{ error.email }}
                  </div>

                </div>

                <!-- PASSWORD -->
                <div class="mb-4">

                  <label class="form-label fw-semibold">
                    Mot de passe
                  </label>

                  <div class="input-group">

                    <input
                      :type="showPassword ? 'text' : 'password'"
                      v-model.trim="password"
                      class="form-control form-control-baraka"
                      :class="{ 'is-invalid': error.password }"
                      placeholder="Votre mot de passe"
                      autocomplete="current-password"
                      :disabled="isLoading"
                    />

                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="showPassword = !showPassword"
                      :disabled="isLoading"
                    >
                      <i
                        :class="
                          showPassword
                            ? 'bi bi-eye-slash'
                            : 'bi bi-eye'
                        "
                      ></i>
                    </button>

                  </div>

                  <div class="invalid-feedback d-block">
                    {{ error.password }}
                  </div>

                </div>

                <!-- OPTIONS -->
                <div
                  class="d-flex justify-content-between align-items-center mb-4"
                >

                  <div class="form-check">

                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="remember"
                      v-model="remember"
                    />

                    <label
                      class="form-check-label"
                      for="remember"
                    >
                      Se souvenir de moi
                    </label>

                  </div>

                  <span class="small text-muted">
                    Version 1.0
                  </span>

                </div>

                <!-- BTN -->
                <button
                  type="submit"
                  class="btn btn-baraka w-100"
                  :disabled="isLoading"
                >

                  <span
                    v-if="isLoading"
                    class="d-inline-flex align-items-center gap-2"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                    ></span>

                    Connexion...
                  </span>

                  <span v-else>
                    <i class="bi bi-box-arrow-in-right me-2"></i>
                    Se connecter
                  </span>

                </button>

              </form>

            </div>

            <!-- FOOTER -->
            <p class="text-center footer-text mt-3 small mb-0">
              © {{ currentYear }} Boutique 
            </p>

          </div>

        </div>

      </div>

    </div>

    <!-- LOADER -->
    <transition name="fade">

      <div
        v-if="isLoading"
        class="global-loader d-flex align-items-center justify-content-center"
      >

        <div class="text-center">

          <div
            class="spinner-border text-light"
            role="status"
            style="width:3rem;height:3rem;"
          ></div>

          <div class="mt-3 text-white">
            Vérification des identifiants...
          </div>

        </div>

      </div>

    </transition>

  </div>
</template>

<script>
export default {
  name: "LoginPage",

  data() {
    return {
      email: "",
      password: "",
      remember: false,
      showPassword: false,
      isLoading: false,

      globalError: this.$route.query.message || "",

      error: {
        email: "",
        password: ""
      }
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },

  methods: {

    validate() {

      this.globalError = "";

      this.error = {
        email: "",
        password: ""
      };

      // EMAIL
      if (!this.email) {

        this.error.email = "L'email est requis.";

      } else {

        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!re.test(this.email)) {
          this.error.email = "Adresse email invalide.";
        }

      }

      // PASSWORD
      if (!this.password) {

        this.error.password =
          "Le mot de passe est requis.";

      }

      return !this.error.email &&
             !this.error.password;

    },

    async login() {

      if (!this.validate() || this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.globalError = "";

      try {

        const result =
          await this.$store.dispatch(
            "authenticate",
            {
              email: this.email,
              password: this.password,
              remember: this.remember
            }
          );

        if (result.success) {

          this.$router.push("/");

        } else {

          this.globalError =
            "Identifiants incorrects.";

        }

      } catch (e) {

        this.globalError =
          "Impossible de se connecter au serveur.";

      } finally {

        this.password = "";
        this.isLoading = false;

      }

    }

  }

};
</script>

<style scoped>

/* =========================
   PAGE
========================= */

.login-page {

  min-height: 100vh;
  width: 100%;
  position: relative;

  background-image:
    url('@/assets/woman-shopping-thrift-store.jpg');

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

}

/* =========================
   OVERLAY
========================= */

.overlay {

  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      135deg,
      rgba(0, 60, 40, 0.88),
      rgba(0, 0, 0, 0.72)
    );

  display: flex;
  align-items: center;
  justify-content: center;

}

/* =========================
   CARD
========================= */

.login-card {

  border: none;

  background: rgba(255,255,255,0.95);

  backdrop-filter: blur(8px);

  animation: fadeUp .5s ease;

}

/* =========================
   LOGO
========================= */

.logo-baraka {

  width: 95px;
  height: 95px;

  object-fit: contain;

}

/* =========================
   TITLE
========================= */

.title-baraka {

  color: #006b4f;

}

/* =========================
   ICON
========================= */

.baraka-icon {

  width: 75px;
  height: 75px;

  margin: auto;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background:
    linear-gradient(
      135deg,
      #006b4f,
      #00996b
    );

  color: white;

  font-size: 30px;

  box-shadow:
    0 10px 30px rgba(0,107,79,.35);

}

/* =========================
   INPUT
========================= */

.form-control-baraka {

  height: 52px;

  border-radius: 12px;

  border: 1px solid #d7d7d7;

  background: rgba(255,255,255,.95);

  transition: .2s ease;

}

.form-control-baraka:focus {

  border-color: #00996b;

  box-shadow:
    0 0 0 4px rgba(0,153,107,.15);

}

/* =========================
   BUTTON
========================= */

.btn-baraka {

  height: 52px;

  border: none;

  border-radius: 12px;

  font-weight: 600;

  color: white;

  background:
    linear-gradient(
      90deg,
      #006b4f,
      #00a878
    );

  transition: .25s ease;

}

.btn-baraka:hover {

  transform: translateY(-2px);

  box-shadow:
    0 10px 20px rgba(0,168,120,.3);

}

/* =========================
   FOOTER
========================= */

.footer-text {

  color: rgba(255,255,255,.8);

}

/* =========================
   LOADER
========================= */

.global-loader {

  position: fixed;
  inset: 0;

  background: rgba(0,0,0,.6);

  z-index: 9999;

}

/* =========================
   ANIMATION
========================= */

.fade-enter-active,
.fade-leave-active {

  transition: opacity .2s ease;

}

.fade-enter-from,
.fade-leave-to {

  opacity: 0;

}

@keyframes fadeUp {

  from {
    opacity: 0;
    transform: translateY(25px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width: 575px) {

  .login-card {

    padding: 1.5rem !important;

  }

}

</style>